import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { select } from '@swf/core/store';

const TournamentMoneyAmount: React.FC = () => {
  const { totalTMoney, totalTMoneyCurrency } = useSelector(select.account.get);
  return totalTMoney ? (
    <CurrencyAmount
      value={totalTMoney}
      currency={totalTMoneyCurrency}
      isZeroExponentCurrency
      currencyDisplay="code"
    />
  ) : null;
};

export default TournamentMoneyAmount;
